import React from 'react';
import './index.scss';
export interface ErrorMessageListItem {
  reportTime: string;
  errorCode: string;
  errorLevel: string;
  errorMessage: string;
  translateMessage: string;
}
const ErrorMessage = (props: { errorList: ErrorMessageListItem[] }) => {
  return (
    <div className='error-message_wrapper'>
      {props.errorList.map((item: ErrorMessageListItem, index: number) => {
        return (
          <div className='error-item' key={item.reportTime + index}>
            <div className='error-info'>
              <div className='high-light'>
                {typeof item.reportTime == 'string'
                  ? item?.reportTime?.substring(11)
                  : item?.reportTime}
              </div>
              <div className='error-code'>错误码：{item.errorCode}</div>
              <div className='error-level'>错误等级：{item.errorLevel}</div>
            </div>
            <div className='error-detail'>{item.errorMessage}</div>
            {item.translateMessage && (
              <div className='error-detail'>
                翻译信息：{item.translateMessage}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(ErrorMessage);
